import axios from 'axios';

const videoTranscoderService = {
  // START config
  url: null,
  setupAjax(token) {
    if (token) {
      axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
    axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
    axios.defaults.headers.common.Accept = 'application/json';
    axios.interceptors.response.use(null, (error) => {
      if (error && error.config && error.config.headers.Authorization && error.response && error.response.status === 401) {
        const oldToken = error.config.headers.Authorization.replace('Bearer ', '');
        return videoTranscoderService.refreshToken(oldToken).then(() => axios.request(error.config)).catch((retryErr) => Promise.reject(retryErr));
      }
      return Promise.reject(error);
    });
  },
  refreshToken(oldToken) {
    return axios.post(`${this.url}authnew/refreshtoken`, { old_token: oldToken });
  },
  getHostingLog(teacherId) {
    return axios.get(`${this.url}hosting-log/${teacherId}`);
  },
  updateHostingLog(data, { cancelToken } = {}) {
    return axios.put(`${this.url}hosting-log`, data, { cancelToken });
  },
  initializeDigitalOceanUpload(data, { cancelToken } = {}) {
    return axios.post(`${this.url}transcode/digitalocean`, data, { cancelToken });
  },
  uploadFileToDigitalOcean({
    file,
    cancelToken,
    onUploadProgress,
  } = {}) {
    return axios({
      method: file.digitalOcean.method,
      url: file.digitalOcean.url,
      headers: file.digitalOcean.headers,
      data: file.data,
      onUploadProgress,
      cancelToken,
      transformRequest: [(data, headers) => {
        delete headers.common.Authorization;
        return data;
      }],
    });
  },
  createTeacherVideo(data, { cancelToken } = {}) {
    return axios.post(`${this.url}video/teacher`, data, { cancelToken });
  },
  initializeTranscodeServices(hostingLogId, { cancelToken } = {}) {
    return axios.get(`${this.url}transcode/services/${hostingLogId}/initialize`, {
      cancelToken,
    });
  },
  verifyTranscodeServices(hostingLogId, { cancelToken } = {}) {
    return axios.get(`${this.url}transcode/services/${hostingLogId}/verify`, {
      cancelToken,
    });
  },
  getVimeoCredentials(data, { cancelToken } = {}) {
    return axios.post(`${this.url}vimeo/credentials`, data, { cancelToken });
  },
  initializeTranscode(data, { cancelToken } = {}) {
    return axios.post(`${this.url}transcode/transcode-pro`, data, { cancelToken });
  },
  updateTranscode(data, { cancelToken } = {}) {
    return axios.put(`${this.url}transcode/transcode-pro`, data, { cancelToken });
  },
  initializeBunnyTranscode(data) {
    return axios.post(`${this.url}transcode/bunny`, data);
  },
  initializeVimeoTranscode(data, { cancelToken } = {}) {
    return axios.post(`${this.url}transcode/vvvvv`, data, { cancelToken });
  },
  updateVimeoTranscode(data, { cancelToken } = {}) {
    return axios.put(`${this.url}transcode/vvvvv`, data, { cancelToken });
  },
  getVimeoUploadStatus(data, { cancelToken } = {}) {
    return axios.post(`${this.url}vvvvv/upload/status`, data, { cancelToken });
  },
  transcodeVideo({
    formData,
    cancelToken,
    teacherId,
    studentId,
    onUploadProgress,
  } = {}) {
    const url = (
      this.url === '/'
      && !window.location.hostname.includes('api-dev')
      && !window.location.hostname.includes('api-stage')
    ) ? 'https://api.playposit.us/' : this.url;
    return axios.post(`${url}transcode/transcode/${teacherId}${studentId ? `/${studentId}` : ''}`, formData, {
      cancelToken,
      onUploadProgress,
    });
  },
  pollMuxUpload({
    muxUploadId,
    teacherId,
    cancelToken,
  } = {}) {
    return axios.get(`${this.url}transcode/mux/poll/upload/${teacherId}/${muxUploadId}`, {
      cancelToken,
    });
  },
  pollMuxAsset({
    muxAssetId,
    teacherId,
    cancelToken,
  } = {}) {
    return axios.get(`${this.url}transcode/mux/poll/asset/${teacherId}/${muxAssetId}`, {
      cancelToken,
    });
  },
};

export default videoTranscoderService;